import { PortalTelemetryScreen } from '../../../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../../app/telemetry/usePortalTelemetry';
import { WorkDetails } from "./WorkDetails";
import { useParams } from "react-router-dom";
import { ActivitiesAcrossDomains } from "./ActivitiesAcrossDomains";
import { CreditSummary } from "./CreditSummary";
import { useAppSelector } from "../../../../app/store/configureStore";
import { useGetActivitiesAcrossDomains } from "../../../../app/customHooks/useGetActivitiesAcrossDomains";
import { ApiRequestStatus } from "../../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { MESSAGE_PROCESSING_DETAILS } from "../../../../app/utils/constant";
import { PcsPlanStatus } from "./PcsPlanStatus";
import { useGetCreditSummary } from "../../../../app/customHooks/useGetCreditSummary";
import PcsPlanLegacySummaryTable from "./PcsPlanLegacySummaryTable";

export function ActivityDetails() {
    const { enrolmentYearId } = useParams<{ enrolmentYearId: string }>();

    const { activitiesAcrossDomains, getActivitiesAcrossDomainsStatus } = useAppSelector(state => state.pcsPdp);
    const { enrolmentYears } = useAppSelector(state => state.pcsEnrolment);
    const { currentYear, summaryData, getCreditSummaryStatus } = useAppSelector(state => state.pcs);

    useGetActivitiesAcrossDomains(true);
    useGetCreditSummary(true);

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.ActivityDetails), undefined, !((getCreditSummaryStatus === ApiRequestStatus.Pending
        || getActivitiesAcrossDomainsStatus === ApiRequestStatus.Pending)));

    if (getCreditSummaryStatus === ApiRequestStatus.Pending
        || getActivitiesAcrossDomainsStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <>
        <PcsPlanStatus />

        {enrolmentYears?.find(x => x.enrolmentYearId === enrolmentYearId)?.year === currentYear &&
            <>
                <WorkDetails />

                {summaryData && summaryData?.length > 0 && currentYear > 2025 && <CreditSummary />}

                {summaryData && summaryData?.length > 0 && currentYear === 2025 && <PcsPlanLegacySummaryTable />}

                {activitiesAcrossDomains?.summaryData?.length !== 0 && <ActivitiesAcrossDomains />}
            </>
        }
    </>
}